import { styled } from "@mui/material/styles";
import ArrowLeftIcon from "@styles/all-images/icons/arrow-left.svg";
import ArrowRightIcon from "@styles/all-images/icons/arrow-right.svg";

interface CustomPaginationProps {
  count: number;
  page: number;
  onChange: (page: number) => void;
}

const PaginationRoot = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "16px",
});

const PaginationContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  border: "1px solid #E9EAEB",
  borderRadius: "8px",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
});

const PageButton = styled("button")(({ disabled }: { disabled?: boolean }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "4px 12px",
  backgroundColor: "white",
  color: "#809199",
  border: "none",
  fontSize: "14px",
  fontWeight: 500,
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.5 : 1,
  "&:first-of-type": {
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
  },
  "&:last-of-type": {
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px",
  },
}));

const PageNumber = styled("span")({
  padding: "4px 12px",
  backgroundColor: "#EDF3F7",
});

export default function CustomPagination({
  count,
  page,
  onChange,
}: CustomPaginationProps) {
  return (
    <PaginationRoot>
      <div className="tw-text-sm font-gray-color">
        Page {page} of {count}
      </div>
      <PaginationContainer>
        <PageButton onClick={() => onChange(page - 1)} disabled={page === 1}>
          <img src={ArrowLeftIcon} alt="Previous" className="tw-w-5 tw-h-5" />
          Previous
        </PageButton>
        <PageNumber>{page}</PageNumber>
        <PageButton
          onClick={() => onChange(page + 1)}
          disabled={page === count}
        >
          Next
          <img src={ArrowRightIcon} alt="Next" className="tw-w-5 tw-h-5" />
        </PageButton>
      </PaginationContainer>
    </PaginationRoot>
  );
}
